import { atom } from "jotai";
import { DocumentTypeDefinitionRecord } from "@/prisma-package/src/entities/document-type-definition.entity";

// Active document type definitions, fetched per scope by
// useDocumentTypeDefinitions. orgId/projectId record which scope the cached
// list was fetched for (orgId null = no org context, global types only;
// projectId null = no project context), so an org or project switch
// triggers a refetch. null = not fetched yet.
export const documentTypeDefinitionsAtom = atom<{
  orgId: string | null;
  projectId: string | null;
  definitions: DocumentTypeDefinitionRecord[];
} | null>(null);
